import type { Preset } from "../hooks/usePeriodAndComparison.js";

export interface DateRangeChipsProps {
  preset: Preset;
  from: string;
  to: string;
  onPreset: (p: Preset) => void;
  onRange: (from: string, to: string) => void;
}

const PRESETS: Array<{ value: Preset; label: string }> = [
  { value: "today",      label: "Сегодня" },
  { value: "yesterday",  label: "Вчера" },
  { value: "7d",         label: "7д" },
  { value: "30d",        label: "30д" },
  { value: "90d",        label: "90д" },
  { value: "this-month", label: "Этот месяц" },
  { value: "custom",     label: "Своё" },
];

const chipBase = {
  background: "var(--surface-card)",
  border: "1px solid var(--border-default)",
  padding: "4px 12px",
  borderRadius: 999,
  fontSize: 12,
  cursor: "pointer",
  fontFamily: "inherit",
  color: "var(--text-primary)",
} as const;

const chipActive = {
  ...chipBase,
  background: "var(--text-primary)",
  color: "var(--text-inverse, #fff)",
  borderColor: "var(--text-primary)",
} as const;

const inputStyle = {
  background: "var(--surface-card)",
  border: "1px solid var(--border-default)",
  color: "var(--text-primary)",
  padding: "4px 8px",
  borderRadius: 6,
  fontSize: 12,
  fontFamily: "inherit",
  width: 130,
} as const;

export function DateRangeChips({ preset, from, to, onPreset, onRange }: DateRangeChipsProps) {
  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      <div style={{ display: "flex", gap: 6 }}>
        {PRESETS.map((p) => (
          <button
            key={p.value}
            onClick={() => onPreset(p.value)}
            style={preset === p.value ? chipActive : chipBase}
          >
            {p.label}
          </button>
        ))}
      </div>
      {preset === "custom" && (
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <input
            type="date"
            value={from}
            onChange={(e) => onRange(e.target.value, to)}
            style={inputStyle}
          />
          <span style={{ color: "var(--text-secondary)", fontSize: 12 }}>—</span>
          <input
            type="date"
            value={to}
            onChange={(e) => onRange(from, e.target.value)}
            style={inputStyle}
          />
        </div>
      )}
    </div>
  );
}
